/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

export const RESET_PC_PIN_VALUES = 'RESET_PC_PIN_VALUES';

export const SET_FIRST_PIN_FOR_CHANGING_PIN = 'SET_FIRST_PIN_FOR_CHANGING_PIN';

export const SET_IS_CHANGE_PIN_OVERLAY_ACTIVE = 'SET_IS_CHANGE_PIN_OVERLAY_ACTIVE';

export const SET_PC_PIN = 'SET_PC_PIN';

export const SET_PC_PIN_SPINNER_ACTIVE = 'SET_PC_PIN_SPINNER_ACTIVE';

export const SET_PC_PIN_SPINNER_DELAY = 'SET_PC_PIN_SPINNER_DELAY';

export const SET_PC_PIN_SUCCESS_CALLBACK = 'SET_PC_PIN_SUCCESS_CALLBACK';

export const SET_PC_PIN_OVERLAY_UI_PROPS = 'SET_PC_PIN_OVERLAY_UI_PROPS';
